export const NAMESPACE = 'manual-test-configuration';

const PLATFORMS = Object.freeze({
  ANDROID: 'android',
  IOS: 'ios',
  LINUX: 'linux',
  MAC: 'mac',
  UNKNOWN: 'unknown',
});

const PLATFORMS_PRETTY = Object.freeze({
  [PLATFORMS.ANDROID]: 'Android',
  [PLATFORMS.IOS]: 'iOS',
  [PLATFORMS.LINUX]: 'Linux',
  [PLATFORMS.MAC]: 'macOS',
});

export default {
  PLATFORMS,
  PLATFORMS_PRETTY,
};
